import React from 'react'
import forOwn from 'mout/object/forOwn'
import { Table, Badge, } from 'reactstrap'

export default function NodeLister (props) {
  let nodesToDisplay = []
  forOwn(props.nodeTags, (val, key, o) => {
    if (val) {
      nodesToDisplay.push(props.nodes[key])
    }
  })
  let rows = <options></options>
  if (nodesToDisplay && nodesToDisplay !== []) {
    rows = nodesToDisplay.map((node, n) => {
      return (
        <tr key={'nodeLister' + n}>
          <td>
            <Badge 
              className='m2clickable' 
              color='danger' 
              onClick={() => props.deleteNodeTag(node.id)}
            >
              X
            </Badge>
            {' '}
            {node.name}
          </td>
        </tr>
      )
    })
  }
  return (
    <Table responsive size="sm">
      <thead>
        <tr>
          <th>Tagged Nodes</th>
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </Table>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/CreateManageContent/NodeLister.js